<template>
  <!--首页-->
  <div>
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search" @click="$router.push({ path: '/search' })"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a sel">首页</router-link>
        </li>
        <li v-for="(item, index) in navList" :key="item.id">
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="a">{{ item.name }}</router-link>
        </li>
      </ul>
    </header>

    <div class="sy_banner">
      <van-swipe class="sy_swipe" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <!-- <router-link :to="`/banner?id=${item.id}`">
            <img :src="item.file" class="img" />
          </router-link> -->
          <a :href="item.url">
            <img :src="item.file" class="img" />
          </a>
        </van-swipe-item>
      </van-swipe>
      <div class="dots">
        <div class="nei">
          <i :class="i == current ? 'sel' : ''" v-for="(item, i) in bannerList" :key="i"></i>
        </div>
      </div>
    </div>
    <div class="big_video">
      <van-swipe class="video_swipe" :loop="isloop" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false">
        <van-swipe-item v-for="(item, i) in videos" :key="i" @click="play(i)">
          <video :src="item.file" class="sp" :class="{ slp: showPlay }" :ref="'video' + i" :poster="'https://bidcdn.zbfit.com/' + item.cover"></video>
          <div class="bo" v-if="showPlay"></div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="modules-template" v-for="(item, index) in modulesList" :key="item.id">
      <!--卡片模块-->
      <div class="main" v-if="item.show_data === '1'">
        <div class="sy_title">
          <span>{{ item.name }}</span>
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="more">更多></router-link>
        </div>
        <ul class="act_list">
          <li v-for="val in item.child" :key="val.id" @click="isdongjian(val.id, index, val.show_data)">
            <router-link to="" class="a">
              <img :src="val.image" alt="" class="img" />
              <div class="title">
                <span>{{ val.name }}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <!--视频模块-->
      <div class="main" v-if="item.show_data === '2'">
        <div class="sy_title">
          <span>{{ item.name }}</span>
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="more">更多></router-link>
        </div>
        <ul class="sy_licai">
          <li v-for="val in item.child" :key="val.id" @click="details(val.id, val.url)">
            <video :src="val.video_file" class="sp" :poster="val.image"></video>
            <div class="bo"></div>
          </li>
        </ul>
      </div>
      <!--  -->

      <!--图文模块-->
      <div class="main" v-if="item.show_data === '3'">
        <div class="sy_title">
          <span>{{ item.name }}</span>
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="more">更多></router-link>
        </div>
        <ul class="touzi_list">
          <li v-for="val in item.child" :key="val.id" @click="details(val.id, val.url)">
            <img :src="val.image" class="img" />
            <span class="type">{{ val.items.name }}</span>
            <div class="right">
              <div class="tit">{{ val.name }}</div>
              <div class="desc">{{ val.describe }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="di_tishi">
      <strong>风险提示 ：</strong><br />
      市场有风险，投资须谨慎。本网站相关观点为当前观点，未来可能随着市场的变化而变化，亦不构成任何投资建议及基金投资收益的保证。
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      current: 0,
      bannerList: [],
      navList: [],
      modulesList: [],
      video: {},
      showPlay: true,
      videos: [],
      videoName: '',
      isloop: true,
    }
  },
  created() {
    this.getBanner()
    this.getHome()
    this.getNav()
    this.getShareInfo()
  },
  methods: {
    //轮播
    onChange(index) {
      this.current = index
    },
    async getBanner() {
      const res = await this.axios.get('/index/banner')
      if (res.code === 1) {
        this.bannerList = res.data.banner
        this.video = res.data.video
        this.videos = res.data.videos
        console.log(res)
      }
    },
    async getHome() {
      const res = await this.axios.get('/index/home')
      if (res.code === 1) {
        this.modulesList = res.data
        console.log(this.modulesList)
      }
    },
    async getNav() {
      const res = await this.axios.get('/index/tabs')
      if (res.code === 1) {
        this.navList = res.data
      }
    },
    details(id, url) {
      if (url) {
        location.href = url
      } else {
        this.$router.push({ path: `/levelThree?id=${id}` })
      }
    },
    play(i) {
      let name = `video${i}`
      this.videoName = name
      console.log(this.$refs[name][0])
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      if (isIOS) {
        this.showPlay = false
        this.isloop = false
        this.$nextTick(function () {
          this.$refs[name][0].play()
        })
      } else {
        console.log('This user is not using iOS.')
        this.showPlay = false
        this.isloop = false
        this.$nextTick(function () {
          this.$refs[name][0].play()
          this.$refs[name][0].requestFullscreen()
          this.$refs[name][0].style
        })
      }
      this.$nextTick(function () {
        this.$refs[name][0].addEventListener('ended', () => {
          this.$refs[name][0].controls = false
          this.showPlay = true
          this.$refs[name][0].load()
        })
      })
    },
    isdongjian(id, index, show_data) {
      if (show_data == 5) {
        this.$router.push(`/dongjian?id=${id}&index=${index}`)
      } else {
        this.$router.push(`/licai2?id=${id}&index=${index}`)
      }
    },
    async getShareInfo() {
      let that = this
      let url = location.href.split('#')[0]
      const res = await this.axios.get(`/index/share?url=${url}`)
      if (res.code === 1) {
        // const { data } = res.data;
        // console.log(data, "1");
        let appId = res.data.appid
        let timestamp = res.data.timestamp
        let nonceStr = res.data.nonceStr
        let signature = res.data.signature
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
        })
        wx.ready(function () {
          //分享到朋友圈
          wx.onMenuShareTimeline({
            title: '招商基金投资者陪伴基地', // 分享时的标题
            link: url, // 分享时的链接
            imgUrl: 'https://bid.zbfit.com/01.jpg', // 分享时的图标
            success: function () {
              console.log('分享成功')
            },
            cancel: function () {
              console.log('取消分享')
            },
          })
          //分享给朋友
          wx.onMenuShareAppMessage({
            title: '招商基金投资者陪伴基地',
            desc: '长期•价值•责任',
            link: url,
            imgUrl: 'https://bid.zbfit.com/01.jpg',
            type: '',
            dataUrl: '',
            success: function () {
              console.log('分享成功')
            },
            cancel: function () {
              console.log('取消分享')
            },
          })
        })
      }
    },
  },
  beforeDestroy() {
    if (this.videoName) {
      this.$nextTick(function () {
        this.$refs[this.videoName][0].pause()
      })
    }
  },
}
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: -0.6rem;
  .top {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.3rem;
    background: #fff;
    .logo {
      display: flex;
      height: 1rem;
      align-items: center;
      .img {
        max-height: 0.46rem;
        margin-right: 0.4rem;
      }
    }
    .search {
      width: 1rem;
      height: 1rem;
      background: url(../assets/img/search.png) no-repeat center center;
      background-size: 0.41rem;
    }
  }
  .nav {
    width: 100%;
    background: url(../assets/img/bg_01.png) no-repeat left top;
    background-size: 100% 100%;
    height: 0.96rem;
    line-height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    li {
      padding: 0;
      margin: 0;
      width: 50%;
      text-align: center;
      height: 0.96rem;
      display: flex;
    }
    .a {
      width: 100%;
      color: #fff;
      font-size: 0.28rem;
      height: 0.8rem;
      display: inline-block;
      line-height: 0.8rem;
      position: relative;
      &.sel {
        font-weight: bold;
        background: url(../assets/img/bg_02.png) no-repeat center 85%;
        background-size: auto 0.02rem;
      }
    }
  }
}
.main {
  padding: 0 0.32rem;
}
.sy_banner {
  position: relative;
  padding-bottom: 0.4rem;
  .sy_swipe {
    .img {
      display: block;
      width: 100%;
    }
  }
  .dots {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
    height: 1.1rem;
    background: url(../assets/img/bg_03.png) no-repeat left top;
    background-size: 100% 100%;
    padding-top: 0.5rem;
    text-align: right;
    padding-right: 0.3rem;
    line-height: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    .nei {
      display: flex;
    }
    i {
      width: 0.1rem;
      height: 0.1rem;
      background: #bebdb9;
      border-radius: 5px;
      display: inline-block;
      margin-left: 8px;
      transition: 0.4s;
    }
    .sel {
      width: 0.9rem;
    }
  }
}
.big_video {
  margin: 0 0.32rem;
  background: #cecdcd;
  box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  // /deep/.van-swipe__track {
  //   width: 100% !important;
  // }
  .bo {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/img/bo.png) no-repeat center center;
    background-size: 0.56rem;
    left: 0;
  }
  .sp {
    width: 100%;
    display: block;
    height: 4rem;
    background: #000;
  }
  .slp {
    object-fit: cover;
  }
}
.sy_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.6rem;
  span {
    width: 2.4rem;
    height: 0.74rem;
    line-height: 0.74rem;
    font-size: 0.3rem;
    background: url(../assets/img/bg_04.png) no-repeat left top;
    background-size: 100% 100%;
    color: #fff;
    padding: 0 0.32rem 0 0.17rem;
    box-sizing: border-box;
    text-align: center;
    margin-left: -0.17rem;
    font-weight: bold;
  }
  .more {
    line-height: 0.5rem;
    color: #666666;
    font-size: 0.22rem;
  }
}
.act_list {
  li {
    margin-bottom: 0.2rem;
    width: 100%;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .img {
      width: 100%;
      display: block;
    }
    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      color: #fff;
      line-height: 0.6rem;
      font-weight: bold;
      span {
        text-shadow: 0.03rem 0.03rem 0.07rem rgba(40, 39, 40, 0.34);
        font-size: 0.52rem;
      }
    }
  }
}
.sy_licai {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: auto;
  box-sizing: border-box;
  height: 4rem;
  margin-bottom: -0.4rem;
  li {
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    display: inline-block;
    width: 3.2rem;
    height: 3.6rem;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 0.15rem;
    background: #fff;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .bo {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/img/bo.png) no-repeat center center;
      background-size: 0.56rem;
      left: 0;
    }
    .sp {
      width: 100%;
      display: block;
      height: 100%;
      background: #000;
      object-fit: cover;
    }
  }
}
.touzi_list {
  li {
    margin-bottom: 0.18rem;
    background: #fff;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    align-items: center;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
  }
  .img {
    width: 2.9rem;
    height: 1.5rem;
    object-fit: cover;
    flex-shrink: 0;
  }
  .type {
    position: absolute;
    top: 3px;
    right: 0.15rem;
    line-height: 0.24rem;
    background: #f7eaec;
    padding: 0 5px;
    color: #e34f66;
    font-size: 0.18rem;
  }
  .right {
    padding: 0.2rem;
    width: 100%;
    .tit {
      padding-left: 0.16rem;
      background: url(../assets/img/bg_05.png) no-repeat left top;
      background-size: 0.08rem;
      color: #4d4d4d;
      font-size: 0.3rem;
      line-height: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc {
      color: #999999;
      line-height: 0.24rem;
      font-size: 0.2rem;
      padding-left: 0.16rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.di_tishi {
  padding: 0.6rem 0.32rem;
  color: rgba(153, 153, 153, 0.59);
  line-height: 0.28rem;
  font-size: 0.18rem;
  font-weight: normal;
}
</style>
